module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('error-page', {
    attrs: {
      "code": "403",
      "description": _vm.description
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-65cf13ec", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65cf13ec"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/errors/403.vue
// module id = 1946
// module chunks = 0